import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch, Redirect } from 'gwx-voyager-components'
import ClientInvitationsListContainer from './List/ClientInvitationsList.react';
import ClientInvitationFormContainer from './Form/ClientInvitationForm.react';

/**
 * Containing component that presents the various Client Invitations
 * components and their respective subroutes.
 */
const ClientInvitations = ({ match }) => (
	<div>
		<Switch>
			<Route exact path={match.path} />
			<Route exact path={`${match.path}/add`} component={ClientInvitationFormContainer} />
			<Redirect to='/pageNotFound' />
		</Switch>
		<ClientInvitationsListContainer />
	</div>
);
ClientInvitations.propTypes = {
	match: PropTypes.shape({
		path: PropTypes.string
	}).isRequired
};

export default ClientInvitations;
